import React, {
  FunctionComponent,
  useEffect,
  useState,
  useRef,
} from "react";
import styles from "../BulkEditModal/BulkEditModal.module.css";
import Modal from "react-modal";
import { IoIosClose } from "react-icons/io";

import Dropdown from "../../DropDown/Dropdown";
import {
  addNoteFirebase,
  changeLeadStage,
  fetchConstants,
  reScheduleTaskFirebase,
  reScheduleTaskMongo,
  addNoteMongo
} from "../../../Services/contacts";

import Loading from "../../Loading/Loading";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../../Redux/actions";
import { useHistory } from "react-router-dom";
import moment from "moment";
import TextInput from "../../TextInput/TextInput";
import {themeColors} from "../../theme";
import Label from "../../Label";
import { motion,AnimatePresence } from "framer-motion";
import Backdrop from "../../Backdrop/Backdrop";
import { getGraceDateForPastApproval } from "../../../Values/utils";

type props = {
  contactDetail: any;
  close: () => void;
  open: boolean;
  tasksData: any[];
  notes: any[];
  user: any;
  theme: any;
  authToken:any;
  organizationData:any;
};

const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 1,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
};

const RescheduleModal: FunctionComponent<props> = ({
  contactDetail,
  close,
  open,
  tasksData,
  notes,
  user,
  theme,
  authToken,
  organizationData
}) => {
  const dateRef: any = useRef();
  const noteRef: any = useRef();
  const [load, setLoad] = useState(false);
  const [nextFollowSelected, setNextFollowSelected] =
    useState<any>({
      label: contactDetail.next_follow_up_type
        ? contactDetail.next_follow_up_type
        : "Select",
      value: contactDetail.next_follow_up_type
        ? contactDetail.next_follow_up_type
        : "Select",
    });

  const dispatcher = useDispatch();
  const history = useHistory();
  const onSubmit = () => {
    let previousDateString = getGraceDateForPastApproval(organizationData.grace_past_days);
    if (
      dateRef.current.value === "") {
      dispatcher(
        showSnackbarAction("`Please Enter A Valid Date!!`", "error")
      );
    } else if (organizationData.is_past_date_approval_enabled == true && (new Date(previousDateString) >= new Date(dateRef.current.value))) { 
      dispatcher(
        showSnackbarAction(
          "Date falls out of grace period allowed for updating tasks!",
          "error"
        )
      );
    }  else if ((organizationData.is_past_date_approval_enabled == false || organizationData.is_past_date_approval_enabled == undefined || organizationData.is_past_date_approval_enabled == null)  && (new Date(dateRef.current.value) < new Date())) { 
      dispatcher(
        showSnackbarAction(
          "Task Cannot be Schedule For Old Date & Time!",
          "error"
        )
      );
    }else {
      setLoad(true);
      if (noteRef.current.value.length !== 0) {
        // addNoteFirebase(
        //   contactDetail.contactId,
        //   notes,
        //   noteRef.current.value,
        //   () => {},
        //   dispatcher,
        //   () => {},
        //   user.user_email
        // );
        addNoteMongo(
          contactDetail.contactId,
          notes,
          noteRef.current.value,
          () => {},
          dispatcher,
          authToken,
          () => {},
          user.user_email,
          contactDetail,
          user.uid
        );
      }
      // reScheduleTaskFirebase(
      //   moment(dateRef.current.value).toDate(),
      //   tasksData,
      //   contactDetail.contactId,
      //   dispatcher,
      //   history
      // );
      reScheduleTaskMongo(
        moment(dateRef.current.value).toDate(),
        tasksData,
        contactDetail.contactId,
        dispatcher,
        history,
        authToken,
        user.uid
      );
    }
  };
  const customStyles = {
    content: {
      backgroundColor:theme ? themeColors.dropdownBackgroundColor:themeColors.dropdownBackgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark
    },
  };
  const containerStyles = { backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}
  return (
    <>
      {load === true && <Loading />}
      {open && <Backdrop>
        <motion.div
                   key="modal"
                   className="card p-4 shadow rounded"
                   style={{position: "absolute",minWidth: "400px",
                   ...containerStyles}}
                   variants={dropIn}
                   initial="hidden"
                   animate="visible"
                   exit="exit"
                 >
      <div className={styles.firstDiv}>
        <h5 
        // className={styles.contactForm}
        >
          Reschedule Task
        </h5>
        <div className={styles.cross} onClick={close}>
          <IoIosClose size={35} color={"#808080"} />
        </div>
      </div>
      <div className={styles.line}></div>

      <div
        className={styles.divide}
        style={{ marginTop: "2rem", width: "100%" }}
      >
        {/* <div className={styles.title}>
          <p className={styles.one}>
            Next Follow Up Date & Time
          </p>
          <p className={styles.two}></p>
        </div> */}
        <Label label="Next Follow Up On" required={false} />
        <div>
          <input
            type="datetime-local"
            placeholder="Enter Date"
            ref={dateRef}
            className={styles.dateInput}
          />
        </div>
      </div>

      {/* <div className={styles.box2}>
       
      </div> */}
      <div
          className={styles.divide}
          style={{ width: "100%",marginTop: "1rem"}}
        >
          {/* <div className={styles.title}>
            <p className={styles.one}>Note</p>
            <p className={styles.two}></p>
          </div> */}
          <Label label="Note" required={false} />
          <div>
            <TextInput
              title={"Enter Note"}
              style={{ backgroundColor: "#fff" }}
              ref={noteRef}
            ></TextInput>
          </div>
        </div>

      <button
        className={styles.apply}
        style={{ marginTop: "2rem" }}
        onClick={onSubmit}
      >
        Save
      </button>
                 </motion.div>
        </Backdrop>}
    </>
    // <Modal
    //   className={styles.parent}
    //   isOpen={open}
    //   shouldCloseOnOverlayClick={true}
    //   overlayClassName={styles.overlay}
    //   shouldCloseOnEsc={true}
    //   onRequestClose={close}
    //   style={customStyles}
    // >
    //   {load === true && <Loading />}
    //   <div className={styles.firstDiv}>
    //     <h5 
    //     // className={styles.contactForm}
    //     >
    //       Reschedule Task
    //     </h5>
    //     <div className={styles.cross} onClick={close}>
    //       <IoIosClose size={35} color={"#808080"} />
    //     </div>
    //   </div>
    //   <div className={styles.line}></div>

    //   <div
    //     className={styles.divide}
    //     style={{ marginTop: "2rem", width: "100%" }}
    //   >
    //     {/* <div className={styles.title}>
    //       <p className={styles.one}>
    //         Next Follow Up Date & Time
    //       </p>
    //       <p className={styles.two}></p>
    //     </div> */}
    //     <Label label="Next Follow Up Date & Time" required={false} />
    //     <div>
    //       <input
    //         type="datetime-local"
    //         placeholder="Enter Date"
    //         ref={dateRef}
    //         className={styles.dateInput}
    //       />
    //     </div>
    //   </div>

    //   {/* <div className={styles.box2}>
       
    //   </div> */}
    //   <div
    //       className={styles.divide}
    //       style={{ width: "100%",marginTop: "1rem"}}
    //     >
    //       {/* <div className={styles.title}>
    //         <p className={styles.one}>Note</p>
    //         <p className={styles.two}></p>
    //       </div> */}
    //       <Label label="Note" required={false} />
    //       <div>
    //         <TextInput
    //           title={"Enter Note"}
    //           style={{ backgroundColor: "#fff" }}
    //           ref={noteRef}
    //         ></TextInput>
    //       </div>
    //     </div>

    //   <button
    //     className={styles.apply}
    //     style={{ marginTop: "auto" }}
    //     onClick={onSubmit}
    //   >
    //     Save
    //   </button>
    // </Modal>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    authToken:state.user.authToken,
    organizationData: state.organization.organizationData,
  };
};

export default connect(mapStateToProps)(RescheduleModal);
